import { useBackgroundQuery, type QueryRef } from '@apollo/client/react';
import { useMemo } from 'react';

import { QueryOrderEnum, EscrowMembersOrderByEnum } from 'src/graphql/schema';
import { EscrowMembersDocument, type IEscrowMembersQuery } from 'src/graphql/actions/escrowMembers/escrowMembers.query';
import { createRequiredContext } from 'src/context/createRequiredContext';

const [useMembersManagement, MembersManagementProvider] = createRequiredContext<{
  addSuccessCallback?: () => void;
  removeSuccessCallback?: () => void;
  queryEscrowMembersRef: QueryRef<IEscrowMembersQuery>;
  escrowPartyId: string;
  canCreateMember: boolean;
}>();

type Props = {
  escrowPartyId: string;
  canCreateMember: boolean;
  addSuccessCallback?: () => void;
  removeSuccessCallback?: () => void;
};

const MembersManagementContextProvider = ({
  children,
  escrowPartyId,
  canCreateMember,
  addSuccessCallback,
  removeSuccessCallback,
}: React.PropsWithChildren<Props>) => {
  const [queryRef] = useBackgroundQuery(EscrowMembersDocument, {
    variables: {
      escrowPartyId,
      page: 1,
      perPage: 100,
      orderBy: EscrowMembersOrderByEnum.Role,
      order: QueryOrderEnum.Asc,
    },
  });

  const queryEscrowMembersRef = useMemo(() => queryRef, [queryRef]);

  const values = {
    escrowPartyId,
    canCreateMember,
    addSuccessCallback,
    removeSuccessCallback,
    queryEscrowMembersRef,
  };

  return <MembersManagementProvider value={values}>{children}</MembersManagementProvider>;
};

export { MembersManagementContextProvider, useMembersManagement };
